import React, { useEffect, useState } from "react";
import { PageHeader } from "@ant-design/pro-layout";
import { useNavigate } from "react-router-dom";
import { Button, Modal, Table, message, Switch  } from "antd";
import { SyncOutlined, UserAddOutlined } from "@ant-design/icons";
import { DispatcherType } from '../../../constants/dispatcher'
import { Page } from '../../../constants/common'
import Requestor from "../../../requestor";
import { getUser } from "../../../states/user/user.reducer";

import { QRCode } from "react-qrcode-logo";
import { useSelector } from "react-redux";
import { debounce } from "lodash";

const Index: React.FC = () => {
  const Navigate = useNavigate();
  const User = useSelector(getUser)!;

  const [messageApi, contextHolder] = message.useMessage();
  const [openQRCode, setOpenQRCode] = useState(false)
  const [list, setList] = useState<DispatcherType[]>([])
  const [pageData, setPagData] = useState({
    page: 1,
    pageSize: 10,
    total: 0,
  })

  // 绑定操作
  // 1. 点击绑定                         -> 创建一组临时内容
  // 2. 用户使用拖车侠小程序扫描          -> 获得临时内容
  // 3. 确认信息并完成绑定                -> 建立绑定关系

  const getSurveyorList = async(page: number, size: number) => {
    try {
      const res = await Requestor.getPartnerAccount<Page<DispatcherType>>({ size, page })
      if (res.error !== '') throw res.error
      setList(res.result.payload)
      setPagData({ page: res.result.page, pageSize: res.result.size, total: res.result.total })
    } catch(err: any) {
      messageApi.error(err);
    }
  }

  // 解绑
  const onUnbind = async(openid: string) => {
    try {
      const res = await Requestor.removeSurveyorRole(openid)
      if (res.error !== '') throw res.error
      messageApi.success('解绑成功!');
      getSurveyorList(pageData.page, pageData.pageSize)
    } catch(err: any) {
      messageApi.error(err);
    }
  }

  const changeSurveyorStatus = async(status: boolean, openid: string) => {
    try {
      const res = status ? await Requestor.enableSurveyor(openid) : await Requestor.disableSurveyor(openid)
      if (res.error !== '') throw res.error
      messageApi.success('查勘员状态切换成功!');
      getSurveyorList(pageData.page, pageData.pageSize)
    } catch(err: any) {
      messageApi.error(err);
    }
  }

  const onSurveyorStatusChange =  debounce((status: boolean, openid: string) => changeSurveyorStatus(status, openid), 500)

  useEffect(() => {
    getSurveyorList(1, 10)
  },[])

  return (
    <div>
      <PageHeader
        title="查勘员管理"
        onBack={() => Navigate(-1)}
        extra={[
          <Button key="refresh" type="primary" icon={<SyncOutlined />} onClick={() => getSurveyorList(1, 10)}>
            刷新
          </Button>,
          <Button 
            key="add" 
            type="primary" 
            icon={<UserAddOutlined />} 
            onClick={() => setOpenQRCode(true)}
          >绑定</Button>,
        ]}
      />
      {contextHolder}
      <div>
        <Table 
          dataSource={list} 
          rowKey={'id'} 
          pagination={{
            current: pageData.page,
            pageSize: pageData.pageSize,
            total: pageData.total,
            onChange: (page, size) => getSurveyorList(page, size),
            showSizeChanger: true,
            showTotal: (total: number, range: [number, number]) =>
              `共${total}条记录，当前第${range[0]}-${range[1]}条`,
          }}
        >
          <Table.Column title="姓名" dataIndex={"name"} />
          <Table.Column title="电话" dataIndex={"phone"} />
          <Table.Column title="所属" dataIndex={"companyName"} />
          <Table.Column 
            title="操作" 
            dataIndex={"operate"}
            render={(_val, record: any) => {
              return (
                <Switch 
                  checkedChildren="启用中" 
                  unCheckedChildren="已禁用"  
                  checked={!record.locked}
                  onChange={val => onSurveyorStatusChange(val, record.openid)}
                />
              )
            }}
          />
        </Table>
      </div>

      <Modal
        title='绑定查勘员'
        open={openQRCode}
        footer={null}
        onCancel={() => setOpenQRCode(false)}
      >
        <div className="flex flex-center">
          <QRCode
            ecLevel="L"
            size={300}
            fgColor="#1890ff"
            value={`{"partnerId": "${User.companyId}", "partnerName": "${User.companyName}"}`}
          />
        </div>
      </Modal>
    </div>
  );
};

export default Index;
